export const hasValidKeys = (obj: Record<string, any>, validKeys: Set<string>): boolean => {
    const keys = Object.keys(obj)
    if (keys.length > validKeys.size) {
        return false
    }

    return keys.every((key: string) => validKeys.has(key))
}
